import { useNavigate } from 'react-router-dom';
import { Breadcrumbs, Button, Card } from './ComponentLibrary';
import SeoHead from './SeoHead';
import { pageMeta } from '../seoUtils';
import './SellerToolsSection.css';

const GUIDE_SECTIONS = [
  {
    title: 'Manage your listings',
    body: 'Review active properties, update availability, and keep listing details current from the agent dashboard.',
  },
  {
    title: 'Track buyer interest',
    body: 'Use recent inquiries and seller feedback to prioritise responses and follow-ups.',
  },
  {
    title: 'Protect your privacy',
    body: 'Adjust what contact and profile information is visible to buyers in Settings → Privacy.',
  },
  {
    title: 'Resolve issues quickly',
    body: 'Use the safety and support pages when you need guidance on moderation, fraud, or account access.',
  },
];

export default function SellerGuidePage() {
  const navigate = useNavigate();
  const seo = pageMeta({
    title: 'Seller Guide',
    description:
      'Tips for sellers and agents on NaijaNest: managing listings, tracking buyer interest, protecting your privacy, and resolving issues.',
    path: '/seller-guide',
  });

  return (
    <section className="section seller-guide-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <div className="settings-section-panel">
        <Breadcrumbs
          items={[
            { label: 'Settings', href: '/settings' },
            { label: 'Seller Tools', href: '/settings' },
            { label: 'Seller Guide', current: true },
          ]}
        />

        <div className="settings-section-heading">
          <h1>Seller Guide</h1>
          <p className="settings-section-sub">
            A quick path to the most common seller tasks and support pages.
          </p>
        </div>

        <div className="seller-guide-grid">
          {GUIDE_SECTIONS.map((section) => (
            <Card key={section.title} className="seller-guide-card">
              <h3>{section.title}</h3>
              <p>{section.body}</p>
            </Card>
          ))}
        </div>

        <div className="seller-guide-actions">
          <Button variant="secondary" onClick={() => navigate('/settings')}>
            Back to Settings
          </Button>
          <Button variant="primary" onClick={() => navigate('/agent')}>
            Open Listings
          </Button>
        </div>
      </div>
    </section>
  );
}
